<!-- <ng-container [formGroup]="this.formGroup">
    <td valign="middle" style="font-weight: 500;">
        <!-- Don't place line spaces between components in the line below bc it will create a char space in the field label
        {{field.label}}<span style="color:red">*</span>:</td>
    <td valign="middle">
        <span *ngFor="let choice of field.choices | keyvalue: originalOrder">
            <label style="font-weight:normal" class="control control--radio aaaaaa ">
                <input type="radio"  [formControlName]="this.fieldKey" value="{{choice.key}}" class="field_submit multi-radio">
                <span *ngIf=" choice.value.value">{{choice.value.value}}</span>
                <span *ngIf="!choice.value.value">{{choice.value}}</span>
                <div class="control__indicator"></div>
            </label>
            <br>
        </span>
    </td>
</ng-container> -->

<div class="field-wrapper" [formGroup]="formGroup">
  
  <div class="field-label" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <label class="mb-0" style="font-weight: 500;">
      {{field.label}}<span style="color:red" *ngIf="field.required">*</span><a *ngIf="field.instructions" class="intructionlink" title="{{field.instructions}}">?</a>:
    </label>
  </div>
  
  <div class="radio-options field-input">
    <span *ngFor="let choice of field.choices | keyvalue: originalOrder" style="display: block; margin-bottom: 8px;">
      <label style="font-weight: normal;" class="control control--radio">
        <input type="radio" [formControlName]="this.fieldKey" value="{{choice.key}}" class="field_submit multi-radio">
        <span *ngIf="choice.value.value">{{choice.value.value}}</span>
        <span *ngIf="!choice.value.value">{{choice.value}}</span>
        <div class="control__indicator"></div>
      </label>
    </span>
  </div>
</div>